module.exports = __webpack_public_path__ + "img/logo-white.742d4549.svg";